import { render, staticRenderFns } from "./Expedition.vue?vue&type=template&id=1241f8c1"
import script from "./Expedition.vue?vue&type=script&lang=js"
export * from "./Expedition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports